// fetch接口请求

import { fetch } from '@/common/request';;


export interface KnowledgeListVo {
  id?: number;
  title: string;
  content: string;
  description?: string;
  createTime?: string;
  updateTime?: string;
}

export function saveKnowledge(params: KnowledgeListVo): Promise<any> {
  return fetch(
    '/api/knowledge/save',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function updateKnowledge(params: KnowledgeListVo): Promise<any> {
  return fetch(
    '/api/knowledge/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function deleteKnowledge(id: number): Promise<any> {
  return fetch(
    '/api/knowledge/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}
export function getKnowledgeList(params: {keyword?: string}): Promise<KnowledgeListVo[]> {
  return fetch(
    '/api/knowledge/list',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
